module.exports = __webpack_public_path__ + "static/img/9.6d603bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/9.jpg
// module id = 329
// module chunks = 0